module.exports = __webpack_public_path__ + "media/images/default_loading_thumbnail-81beffbf.png";